import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/employees",
      name: "employees",
      meta: { requiresAuth: true, title: "routes.employees" },
      component: () => import("./main.vue")
    },
    {
      path: "/module/employees/employeeSettings",
      name: "employeeSettings",
      meta: { requiresAuth: true, title: "routes.employeeSettings" },
      component: () => import("./employeeSettings.vue")
    }
  ]
};
